import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  return (
    <div className="flex1 justify-center">
      <div className="flex1 flex-col items-center">
       
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
          <p>
          <strong>Welcome to Experiment 2: DES Encryption Simulator!</strong> Building on your knowledge from Experiment 1, where you learned about the generation of the 48-bit encryption key, now dive into DES encryption mechanics
<br/><br/>
→ Input a 64-bit binary sequence as your plaintext and Enter the Encryption Key. Click "Next" to initiate encryption. For clarity, the data is presented as a matrix.
<br/><br/>

→ Navigate through the encryption rounds using "next" and "previous". Witness transformations on both the left and right 32 bits during each phase
<br/><br/>

→ After completing the first k rounds, your challenge is to compute the k+1th intermediate result. A successful calculation advances the simulation.
<br/><br/>

→ Encounter any missteps? The simulator provides feedback for adjustments. Utilize the "PREVIOUS" button for step retracing.
<br/><br/>

→ To Complete this Experiment the student has to identify the 32-bit left and right output
<br/><br/>

→ Recommendation: Retain a technical journal for tracking insights and inquiries. Engage to truly comprehend DES encryption's underpinnings
          </p>
        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
